import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  NgSelectComponent,
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
} from '@ng-select/ng-select';
import { AccordionComponent } from '../../../../../shared/components/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../shared/components/accordion/accordion-item.component';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';
import { LoadingComponent } from '../../../../../shared/components/loading/loading.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { PaginationComponent } from '../../../../../shared/components/pagination/pagination.component';
import { FeatherPipe } from '../../../../../core/pipes/feather.pipe';
import { InventoryHistoryBase } from './inventory-history-base';

@Component({
  selector: 'app-inventory-history-var-l',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    AccordionComponent,
    AccordionItemComponent,
    AlertComponent,
    LoadingComponent,
    ButtonComponent,
    PaginationComponent,
    FeatherPipe,
  ],
  templateUrl: './variation-l.component.html',
  styleUrl: './sku-inventory-history.component.scss',
})
export class InventoryHistoryVarLComponent extends InventoryHistoryBase implements OnInit {
  filtersExpanded = true;
  datetimeFrom = '';
  datetimeTo = '';
  showFromPopover = false;
  showToPopover = false;

  ngOnInit(): void {
    this.setDatePreset('7d');
  }

  @HostListener('document:click')
  override onDocumentClick(): void {
    super.onDocumentClick();
    this.closePopovers();
  }

  toggleFromPopover(event: Event): void {
    event.stopPropagation();
    this.showFromPopover = !this.showFromPopover;
    this.showToPopover = false;
  }

  toggleToPopover(event: Event): void {
    event.stopPropagation();
    this.showToPopover = !this.showToPopover;
    this.showFromPopover = false;
  }

  closePopovers(): void {
    this.showFromPopover = false;
    this.showToPopover = false;
  }

  applyFromPreset(preset: 'today' | '7d' | '30d' | 'month'): void {
    const today = new Date();
    const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

    switch (preset) {
      case 'today':
        this.dateFrom = fmt(today);
        break;
      case '7d': {
        const d = new Date(today);
        d.setDate(d.getDate() - 7);
        this.dateFrom = fmt(d);
        break;
      }
      case '30d': {
        const d = new Date(today);
        d.setDate(d.getDate() - 30);
        this.dateFrom = fmt(d);
        break;
      }
      case 'month':
        this.dateFrom = fmt(new Date(today.getFullYear(), today.getMonth(), 1));
        break;
    }
    this.timeFrom = '00:00';
    this.datetimeFrom = `${this.dateFrom}T${this.timeFrom}`;
    this.activePreset = preset;
    this.showFromPopover = false;

    if (!this.dateTo) {
      this.dateTo = fmt(today);
      this.timeTo = '23:59';
      this.datetimeTo = `${this.dateTo}T${this.timeTo}`;
    }
  }

  applyToPreset(preset: 'today' | '7d' | '30d' | 'month'): void {
    const today = new Date();
    const fmt = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    this.dateTo = fmt(today);
    this.timeTo = '23:59';
    this.datetimeTo = `${this.dateTo}T${this.timeTo}`;
    this.showToPopover = false;
  }

  searchAndCollapse(): void {
    this.syncDatetimeToFields();
    this.search();
  }

  onDatetimeFromChange(): void {
    this.syncDatetimeToFields();
    if (this.datetimeFrom && this.datetimeTo && this.datetimeFrom > this.datetimeTo) {
      this.datetimeTo = this.datetimeFrom;
    }
    this.activePreset = null;
  }

  onDatetimeToChange(): void {
    this.syncDatetimeToFields();
    if (this.datetimeFrom && this.datetimeTo && this.datetimeTo < this.datetimeFrom) {
      this.datetimeFrom = this.datetimeTo;
    }
    this.activePreset = null;
  }

  private syncDatetimeToFields(): void {
    if (this.datetimeFrom) {
      const [date, time] = this.datetimeFrom.split('T');
      this.dateFrom = date;
      this.timeFrom = time || '';
    } else {
      this.dateFrom = '';
      this.timeFrom = '';
    }
    if (this.datetimeTo) {
      const [date, time] = this.datetimeTo.split('T');
      this.dateTo = date;
      this.timeTo = time || '';
    } else {
      this.dateTo = '';
      this.timeTo = '';
    }
  }

  get fromDisplayValue(): string {
    if (!this.datetimeFrom) return 'Selecionar...';
    const [date, time] = this.datetimeFrom.split('T');
    const [y, m, d] = date.split('-');
    return `${d}/${m}/${y} ${time || '00:00'}`;
  }

  get toDisplayValue(): string {
    if (!this.datetimeTo) return 'Selecionar...';
    const [date, time] = this.datetimeTo.split('T');
    const [y, m, d] = date.split('-');
    return `${d}/${m}/${y} ${time || '23:59'}`;
  }

  override setDatePreset(preset: 'today' | '7d' | '30d' | 'month'): void {
    super.setDatePreset(preset);
    this.datetimeFrom = this.dateFrom ? `${this.dateFrom}T00:00` : '';
    this.datetimeTo = this.dateTo ? `${this.dateTo}T23:59` : '';
  }

  override clearAllFilters(): void {
    super.clearAllFilters();
    this.setDatePreset('7d');
  }
}
